import React from 'react';

const View = (props) => {
  return <div dangerouslySetInnerHTML={{ __html: props.data.html }}></div>;
};

export default View;
